<template >
   <div>
    <div v-if="isLogin">
      <InnerHeader />
    </div>
    <div v-else>
      <OuterHeader
        ref="OuterHeader"
        @showRegister="showRegister()"
        @closeRegister="closeRegister()" />
    </div>
  </div>
  <div id="contact-page">
    <main role="main">
      <div class="page-content" >
        <div class="container py-md-5 py-4">
          <div class="mb-4">
            <img src="/images/contact-banner.jpg" class="img-fluid" alt="" />
          </div>

          <div class="row justify-content-between">
            <div class="col-md-5" v-for="(data, index) in detail" :key="index">
              <h3 class="font-20 text-uppercase">
                {{ data.branch_name }} 
              </h3>
              <p>
                {{ data.address }}
              </p>
              <p>
                <a :href="'mailto:' + data.email" class="cursor-pointer"
                  ><span class="me-2"
                    ><i class="fa fa-envelope" aria-hidden="true"></i></span
                  >{{ data.email }}</a
                >
              </p>
              <p>
                <a :href="'tel:' + data.phone"
                  ><span class="me-2"
                    ><i class="fa fa-phone" aria-hidden="true"></i
                  ></span>
                  {{ data.phone }}</a
                >
              </p>
            </div>
            <!-- <div class="col-md-5">
              <h3 class="font-20 text-uppercase">Phaltan Office</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
              <p>
                <a href="mailti:contact@gmail.com "
                  ><span class="me-2"
                    ><i class="fa fa-envelope" aria-hidden="true"></i></span
                  >contact@gmail.com</a
                >
              </p>
              <p>
                <a href="tel:+918738728292"
                  ><span class="me-2"
                    ><i class="fa fa-phone" aria-hidden="true"></i
                  ></span>
                  +918738728292</a
                >
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </main>
  </div>
      <SubFooter ref="SubFooter" @showRegister="showRegister()" />
      <MainFooter ref="MainFooter" @showRegister="showRegister()" />
      <SignUp ref="signupModal" />
</template>
<script>
import OuterHeader from "@/components/OuterHeader";
import MainFooter from "@/components/MainFooter";
import SignUp from "../../components/signup.vue";
import SubFooter from "@/components/SubFooter.vue";
import InnerHeader from "@/components/InnerHeader.vue";
export default {
  name: "ContactUs",
  components: {
    OuterHeader,
    MainFooter,
    SignUp,
    InnerHeader,
    SubFooter,
  },
  data() {
    return {
      detail: [],
      isShow: localStorage.getItem('access_token')? true : false,
      mobile: this.$route.query.mobile,
      isLogin: localStorage.getItem("access_token") ?? null,
    };
  },
  mounted() {
    this.getDetail();
    window.scrollTo(-10000, -10000);
  },
  methods: {
    showRegister() {
      this.$refs.signupModal.showModal();
    },
    closeRegister() {
      this.$refs.signupModal.closeModal();
    },
    getDetail() {
      this.$api
        .getAPI({
          _action: "/contact-us/list",
        })
        .then((res) => {
          this.detail = res.list;
        })
        .catch(() => {});
    },
  },
};
</script>
